var Layout = require("app/ui/Layout"),
    get    = require("object-path").get,
    kind   = require("enyo/kind");

module.exports = kind(/** @lends  app.HomePage.PrefixLayout.prototype */ {

    /**
     * @private
     */
    name: "app.HomePage.PrefixLayout",

    /**
     * @private
     */
    kind: Layout,

    /**
     * @public
     */
    reflow: function() {
        var $container     = this.container,
            scrollerWidth  = get($container, "scrollerDimensions.scrollerWidth", 0),
            scrollerHeight = get($container, "scrollerDimensions.scrollerHeight", 0),
            numDashboards  = get($container, "state.data.dashboard.length", 0);

        if (!$container.hasNode()) {
            return;
        }

        $container.addStyles({
            width:     scrollerWidth + "px",
            minHeight: numDashboards === 0 ? scrollerHeight + "px" : null
        });

        this.reflowHeader();
    },

    /**
     * @public
     */
    reflowHeader: function() {
        var $container = this.container,
            graphicHeight,
            graphicOverflow,
            contentHeight;

        graphicHeight   = get($container, "headerGraphicLayoutMetrics.graphicHeight", 0);
        graphicOverflow = get($container, "headerGraphicLayoutMetrics.graphicOverflow", 0);
        contentHeight   = get($container, "headerContentLayoutMetrics.contentHeight", 0);

        $container.$.header.addStyles({
            height: Math.max(0, graphicHeight - graphicOverflow, contentHeight) + "px"
        });
    }

});
